import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useIntegralPath from '../../hooks/useIntegralPath';
import { usePanelPreferences } from '../../hooks/usePanelPreferences';
import IntegralResizable from './IntegralResizable';
function Integral({ integral, isActive, nucleus }) {
    const path = useIntegralPath(integral);
    const integralPreferences = usePanelPreferences('integrals', nucleus);
    return (_jsxs("g", { children: [_jsx("path", { className: "line", stroke: integralPreferences.color, strokeWidth: integralPreferences.strokeWidth, fill: "none", style: {
                    opacity: isActive ? 1 : 0.2,
                }, d: path }), _jsx(IntegralResizable, { integralData: integral, integralFormat: integralPreferences.relative.format })] }));
}
export default Integral;
